import React from "react";
import Gallery from "./components/Gallery";

export default function Test() {
  return <Gallery />
}
